import { Button, Paper } from '@mui/material';
import React, { useState } from 'react';
import { showPaymentForm } from '../../../services/app/api';
import { useAuth } from '../../../contexts/Auth';
import { useSnackbar } from '../../../hooks';
import BlockingLoader from '../../UI/BlockingLoader';
import { formatToUSMoney } from '../../../utils/GenericFunctions';

const AskForPayment = ({ applicantData }) => {
    const [loading, setLoading] = useState(false);
    const auth = useAuth();
    const snackbar = useSnackbar();

    const openPaymentForm = () => {
        setLoading(true);
        showPaymentForm({ user_id: auth?.getProfileId(), sponsorship_id: applicantData?.id })
            .then((res) => {
                localStorage.setItem('redirectTo', window.location.href);
                window.open(res?.data?.data?.url, '_self');
            })
            .catch(() => {
                snackbar.error('Failed to open payment form');
            })
            .finally(() => {
                setLoading(false);
            });
    };
    return (
        <Paper elevation={2} sx={{ padding: 5, margin: '25px auto', borderRadius: '8px' }}>
            <BlockingLoader loading={loading} />
            <p className="text-center text-3xl font-semibold text-primary font-geometric">
                You have {applicantData?.applicants_count || 0} new applicant!
            </p>
            <p className="text-center text-xl mt-4 text-primary font-geometric">
                To review and accept applicants, please pay the opportunity fee.
            </p>
            <p className="text-2xl text-center my-5 ">
                Total amount to pay: {applicantData?.fee_amount ? formatToUSMoney(applicantData?.fee_amount) : 0}{' '}
            </p>
            <div className="m-auto w-60">
                {' '}
                <Button onClick={openPaymentForm} className="" variant="contained" color="secondary" fullWidth>
                    {' '}
                    Pay Now{' '}
                </Button>
            </div>
        </Paper>
    );
};

export default AskForPayment;
